import PermissionService from '@Services/PermissionService';

export default {
	dashboard: {
		label: 'Dashboard',
		icon: 'dashboard',
		link: 'dashboard',
		pm: () => false,
	},
	clients: {
		label: 'Clients',
		icon: 'user',
		link: 'clients',
		pm: (permissions) => PermissionService(permissions).getClientsList(),
	},
	accounts: {
		label: 'Accounts',
		icon: 'accounts',
		link: 'accounts',
		pm: (permissions) => PermissionService(permissions).getAccountsList(),
	},
	transactions: {
		label: 'Transactions',
		icon: 'transactions',
		link: 'transactions',
		pm: (permissions) => PermissionService(permissions).getOrders(),
	},
	transactionCurrency: {
		label: 'Transaction currency',
		icon: 'currency',
		link: 'transaction_currency',
		pm: (permissions) => PermissionService(permissions).getOrders(),
	},
	admin: {
		label: 'Admin Panel',
		icon: 'admin',
		link: null,
		pm: (permissions) => PermissionService(permissions).getUsersList(),
		sub: {
			users: {
				label: 'Accounts',
				link: 'userslist',
				pm: (permissions) => PermissionService(permissions).getUsersList(),
			},
		}
	},
	deals: {
		label: 'Deals',
		icon: 'deals',
		link: null,
		pm: (permissions) =>
			[
				PermissionService(permissions).getActiveDeals(),
				PermissionService(permissions).getCloseDeals(),
			].some((item) => item),
		sub: {
			active: {
				label: 'Active',
				link: 'deals_active',
				pm: (permissions) => PermissionService(permissions).getActiveDeals(),
			},
			history: {
				label: 'History',
				link: 'deals_history',
				pm: (permissions) => PermissionService(permissions).getCloseDeals(),
			},
		}
	}
}
